export function formatDate(dateString, withTime = false, treatAsUTC = false) {
  if (
    !dateString ||
    dateString.startsWith('1900') ||
    dateString.startsWith('0001')
  ) {
    return '--';
  }

  let date;

  if (treatAsUTC) {
    const normalized = dateString.endsWith('Z') ? dateString : `${dateString}Z`;

    date = new Date(normalized);
  } else {
    date = new Date(dateString);
  }

  if (isNaN(date)) return '--';

  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();

  if (!withTime) {
    return `${day}/${month}/${year}`;
  }

  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');

  return `${day}/${month}/${year} ${hours}:${minutes}`;
}

export function removeTime(dateString) {
  if (!dateString) return '';

  if (dateString.includes('T')) {
    return dateString.split('T')[0];
  }

  if (dateString.includes(' ')) {
    return dateString.split(' ')[0];
  }

  return dateString;
}

export function parseLocalDate(dateString) {
  if (!dateString) return null;

  const [year, month, day] = dateString.split('-').map(Number);

  if (!year || !month || !day) return null;

  return new Date(year, month - 1, day);
}

export function formatDateByLocale(dateString, locale) {
  if (
    !dateString ||
    dateString.startsWith('1900') ||
    dateString.startsWith('0001')
  ) {
    return '--';
  }

  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return '--';

  return new Intl.DateTimeFormat(locale).format(date);
}
